import { render, staticRenderFns } from "./ListaUsuarios.vue?vue&type=template&id=0d79fa52"
import script from "./ListaUsuarios.vue?vue&type=script&lang=js"
export * from "./ListaUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports